import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "app-nav-locale-picker"
};
const _hoisted_2 = ["aria-expanded"];
const _hoisted_3 = {
  class: "app-nav-locale-picker__flag",
  "aria-hidden": "true"
};
const _hoisted_4 = {
  class: "app-nav-menu__label"
};
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = ["aria-selected", "onClick"];
const _hoisted_7 = {
  class: "app-nav-locale-picker__flag",
  "aria-hidden": "true"
};
const _hoisted_8 = {
  class: "app-nav-locale-picker__option-text"
};
const _hoisted_9 = ["lang"];
const _hoisted_10 = {
  key: 0,
  class: "app-nav-locale-picker__option-meta"
};
const _hoisted_11 = {
  key: 0,
  class: "app-nav-locale-picker__check",
  "aria-hidden": "true"
};
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ArrowLeft } from '@element-plus/icons-vue';
import { LOCALE_OPTIONS, findLocaleOption } from '@/config/localeOptions';
export default {
  __name: 'AppNavLocalePicker',
  emits: ['switch-locale'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      locale
    } = useI18n();
    const expanded = ref(false);
    const currentOption = computed(() => findLocaleOption(locale.value));
    function select(code) {
      expanded.value = false;
      emit('switch-locale', code);
    }
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["app-nav-menu__row app-nav-locale-picker__trigger", {
          'is-open': expanded.value
        }]),
        "aria-expanded": expanded.value,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => expanded.value = !expanded.value, ["stop"]))
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(currentOption.value.flag), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(currentOption.value.label), 1), _createVNode(_component_el_icon, {
        class: _normalizeClass(["app-nav-locale-picker__chevron", {
          'is-open': expanded.value
        }]),
        "aria-hidden": "true"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowLeft))]),
        _: 1
      }, 8, ["class"])], 10, _hoisted_2), _withDirectives(_createElementVNode("div", {
        class: "app-nav-locale-picker__panel",
        role: "listbox",
        "aria-label": _ctx.$t('nav.selectLanguage')
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LOCALE_OPTIONS), lang => {
        return _openBlock(), _createElementBlock("button", {
          key: lang.code,
          type: "button",
          class: _normalizeClass(["app-nav-locale-picker__option", {
            'is-active': _unref(locale) === lang.code
          }]),
          role: "option",
          "aria-selected": _unref(locale) === lang.code,
          dir: "ltr",
          onClick: _withModifiers($event => select(lang.code), ["stop"])
        }, [_createElementVNode("span", _hoisted_7, _toDisplayString(lang.flag), 1), _createElementVNode("span", _hoisted_8, [_createElementVNode("span", {
          class: "app-nav-locale-picker__option-label",
          lang: lang.code
        }, _toDisplayString(lang.label), 9, _hoisted_9), lang.nameZh && lang.nameZh !== lang.label ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(lang.nameZh), 1)) : _createCommentVNode("", true)]), _unref(locale) === lang.code ? (_openBlock(), _createElementBlock("span", _hoisted_11, "✓")) : _createCommentVNode("", true)], 10, _hoisted_6);
      }), 128))], 8, _hoisted_5), [[_vShow, expanded.value]])]);
    };
  }
};